var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 8.99935C28.6917 8.99935 30.3333 7.35773 30.3333 5.33268C30.3333 3.30764 28.6917 1.66602 26.6667 1.66602C24.6416 1.66602 23 3.30764 23 5.33268C23 7.35773 24.6416 8.99935 26.6667 8.99935Z",
    fill: "#E00000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6667 10.666C23.7201 10.666 21.3334 8.27935 21.3334 5.33268C21.3334 4.35935 21.6134 3.45268 22.0801 2.66602H9.33342C5.65341 2.66602 2.66675 5.63935 2.66675 9.30602V17.2793V18.6127C2.66675 22.2794 5.65341 25.2527 9.33342 25.2527H11.3334C11.6934 25.2527 12.1734 25.4927 12.4001 25.786L14.4001 28.4394C15.2801 29.6127 16.7201 29.6127 17.6001 28.4394L19.6001 25.786C19.8534 25.4527 20.2534 25.2527 20.6667 25.2527H22.6667C26.3467 25.2527 29.3334 22.2794 29.3334 18.6127V9.91935C28.5467 10.386 27.6401 10.666 26.6667 10.666Z",
    fill: "#4DAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 16.0007C15.2534 16.0007 14.6667 15.4007 14.6667 14.6673C14.6667 13.934 15.2667 13.334 16.0001 13.334C16.7334 13.334 17.3334 13.934 17.3334 14.6673C17.3334 15.4007 16.7467 16.0007 16.0001 16.0007Z",
    fill: "#4DAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 16.0007C20.5867 16.0007 20 15.4007 20 14.6673C20 13.934 20.6 13.334 21.3333 13.334C22.0667 13.334 22.6667 13.934 22.6667 14.6673C22.6667 15.4007 22.08 16.0007 21.3333 16.0007Z",
    fill: "#4DAF50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 16.0007C9.91992 16.0007 9.33325 15.4007 9.33325 14.6673C9.33325 13.934 9.93325 13.334 10.6666 13.334C11.3999 13.334 11.9999 13.934 11.9999 14.6673C11.9999 15.4007 11.4133 16.0007 10.6666 16.0007Z",
    fill: "#4DAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNotification);
export default __webpack_public_path__ + "static/media/sms-notification.97d2c746c12e59fdc076bdefbfe1af80.svg";
export { ForwardRef as ReactComponent };